// @flow

export const STAFF_VALUE = 'staff'
export const TENANT_VALUE = 'tenant'

export const DWELLER_ROLE_VALUE = 'dweller'
export const LANDLORD_ROLE_VALUE = 'landlord'
